<template>
  <div>
    <b-button
      id="btn-excel"
      ref="btnexcel"
      variant="primary"
      size="sm"
      style="
        margin-right: 1%;
        background: #37ef00 !important;
        border-color: #37ef00 !important;
      "
      @click="cargarDatosTrayectos((excel_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-excel" />
    </b-button>
    <b-button
      id="btn-pdf"
      variant="danger"
      size="sm"
      @click="cargarDatosTrayectos((excel_btn = ''), (pdf_btn = '1'))"
    >
      <font-awesome-icon icon="fa-solid fa-file-pdf" />
    </b-button>

    <b-card-code class="principal mt-2">
      <b-col cols="12" class="pr-0 pl-0 mt-2">
        <b-card-title class="font-medium-2" style="text-align: center">
          <span>Tabla de trayectos</span>
        </b-card-title>

        <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            class="mb-1"
          >
            <template v-slot:cell(trayecto)="data">
              <span
                v-b-tooltip.hover
                :title="
                  data.item.origen.nombre + ' - ' + data.item.destino.nombre
                "
                >{{
                  data.item.origen.codigo + " - " + data.item.destino.codigo
                }}</span
              >
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-overlay>
      </b-col>

      <!--      <b-col-->
      <!--        cols="12" class="mb-2"-->
      <!--      >-->
      <!--        <b-pagination-->
      <!--          v-model="currentPage"-->
      <!--          :total-rows="items.length"-->
      <!--          :per-page="perPage"-->
      <!--          first-number-->
      <!--          last-number-->
      <!--          class="mb-0"-->
      <!--          align="center"-->
      <!--          prev-class="prev-item"-->
      <!--          next-class="next-item"-->
      <!--        >-->
      <!--          <template #prev-text>-->
      <!--            <feather-icon-->
      <!--              icon="ChevronLeftIcon"-->
      <!--              size="18"-->
      <!--            />-->
      <!--          </template>-->
      <!--          <template #next-text>-->
      <!--            <feather-icon-->
      <!--              icon="ChevronRightIcon"-->
      <!--              size="18"-->
      <!--            />-->
      <!--          </template>-->
      <!--        </b-pagination>-->
      <!--      </b-col>-->
    </b-card-code>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BImg,
  BCardHeader,
  BCardGroup,
  BCardTitle,
  VBTooltip,
  BOverlay,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import actions from "@/assets/utils/utils";
import $ from "jquery";
import Vue from "vue";

export default {
  components: {
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    BOverlay,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      login_user: "",
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "origen.nombre",
          label: "Origen",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "destino.nombre",
          label: "Destino",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "trayecto",
          label: "Trayecto",
          sortable: true,
          thClass: "text-center",
        },
      ],
      items: [],
      mostrarLoader: false,
    };
  },
  computed: {
    sortOptions() {
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  mounted() {
    actions.setearTitulo("");
    this.cargarDatosTrayectos();
    this.totalRows = this.items.length;
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("log_tray_consultar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    cargarDatosTrayectos(excel_btn = "", pdf_btn = "") {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getAllTrayectos($excel: String!, $pdf: String!){
                    getAllTrayectos(excel:$excel, pdf:$pdf){
                        trayectos{
                            token,
                            origen{
                                codigo,
                                nombre
                            },
                            destino{
                                codigo,
                                nombre
                            },
                            producto{
                                codigo,
                                nombre
                            }
                        },
                        dataarchivo,
                        status,
                        message
                    }
                }`,
          variables: {
            excel: excel_btn,
            pdf: pdf_btn,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getAllTrayectos.status === "success") {
              if (response.data.data.getAllTrayectos.trayectos) {
                this.items = response.data.data.getAllTrayectos.trayectos;
              } else {
                if (excel_btn === "1") {
                  var data = response.data.data.getAllTrayectos.dataarchivo;
                  actions.cargarArchivos(
                    data,
                    "Trayectos.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  var data = response.data.data.getAllTrayectos.dataarchivo;
                  actions.cargarArchivos(
                    data,
                    "Trayectos.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
</style>
